<template>
  <!-- As medidas saem como custom properties, e não como `height`/`font-size`
       diretos, pra que a media query de tela estreita em theme.css consiga
       encolher o lockup sem precisar brigar com estilo inline. -->
  <span
    class="marca"
    :class="{ 'marca--claro': claro }"
    :style="{ '--marca-h': size + 'px', '--marca-fs': fontSize + 'px' }"
  >
    <img :src="arte" alt="" class="marca-logo" />
    <span>
      <span class="marca-nome">FLOR DE GOIÁS</span>
      <span class="marca-sub">Transportadora</span>
    </span>
  </span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  size: { type: [Number, String], default: 34 },
  fontSize: { type: [Number, String], default: 17 },
  claro: { type: Boolean, default: false },
})

// Duas artes em vez de filtro CSS: em fundo escuro a cabine (#12465a) some.
const arte = computed(() => props.claro
  ? require('@/assets/img/logo-claro.svg')
  : require('@/assets/img/logo.svg'))
</script>
